<svg (mouseenter)="mouseEnter()"
     (mouseleave)="mouseLeave()"
     [attr.height]="height"
     [attr.width]="width"
     [class.cursor-pointer]="isButton"
     [attr.fill]="bgColor"
     viewBox="0 0 24 24"
     xmlns="http://www.w3.org/2000/svg">
  <circle [attr.stroke]="color" cx="12" cy="12"
          r="11.5"/>
  <path [attr.stroke]="crossColor"
        d="M15.5355 8.46522L8.46447 15.5363M15.5355 15.5363L8.46447 8.46522"
        stroke-width="2"/>
</svg>